import { inject } from 'vue';
import { CONFIG_INJECTION_KEY } from '../../shared/config';

export function useConfig() {
  return inject(CONFIG_INJECTION_KEY, undefined);
}
